import React, { FC } from 'react';

import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';

import { fallbackText } from '@pharmaplan/common';

import strings from '../../../localization';
import DisplayChip from '../../common/DisplayChip';

interface ILeadDetails {
  name: string;
  email: string;
  phone: string;
  statusLabel: string;
  statusStyle:Record<string, any>;
  notes: string;
}

const labelSx = { fontSize: 14, fontWeight: 500, color: 'grey.800' };
const valueSx = { color: 'grey.900', wordBreak: 'break-word', fontSize: 14 };

const Row = ({ label, value }: { label: string; value: string }) =>
  (
    <Grid container xs={12} sx={{ mb: 1.5 }}>
      <Grid item xs={4}>
        <Typography sx={labelSx}>{label}</Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography sx={valueSx}>{value || '-'}</Typography>
      </Grid>
    </Grid>
  );

const LeadDetails: FC<ILeadDetails> = ({ name, email, phone, statusLabel, notes, statusStyle }) =>
  (
    <Box sx={{ px: 3, pb: 3, pt: 2, minWidth: 360 }}>
      <Row label={strings.name} value={name || fallbackText} />
      <Row label={strings.email} value={email || fallbackText} />
      <Row label={strings.phone} value={phone || fallbackText} />

      <Grid container xs={12} sx={{ mb: 1.5 }}>
        <Grid item xs={4}>
          <Typography sx={labelSx}>{strings.status}</Typography>
        </Grid>
        <Grid item xs={8}>
          <DisplayChip style={{ ...statusStyle, paddingX: 0 }} value={statusLabel} />
        </Grid>
      </Grid>
      <Row label={strings.notes} value={notes || fallbackText} />
    </Box>
  );

export default LeadDetails;
